const items = [
  "MS Pipes",
  "TMT Rods",
  "MS Square Pipes",
  "MS Angles",
  "MS Flats",
  "MS Channels",
  "GI Items",
  "Buying & Selling of Scrap",
  "Iron /// Plastic /// Vehicle",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div
      className="border-b border-[#262626] py-6 overflow-hidden bg-[#050505]"
      data-testid="product-marquee"
    >
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-2xl md:text-4xl uppercase tracking-tight text-outline px-6">
              {item}
            </span>
            <span className="text-[#3f3f3f] text-xl">///</span>
          </span>
        ))}
      </div>
    </div>
  );
}
